import Hero from '../components/sections/Hero';
import FoodRibbon from '../components/sections/FoodRibbon';
import Features from '../components/sections/Features';
import HowItWorks from '../components/sections/HowItWorks';
import WhyHooshpaz from '../components/sections/WhyHooshpaz';
import AppPreview from '../components/sections/AppPreview';
import Cookbook from '../components/sections/Cookbook';
import Pricing from '../components/sections/Pricing';
import FAQ from '../components/sections/FAQ';
import CTA from '../components/sections/CTA';

const Home = () => (
    <div className="home-page">
        <Hero />
        <FoodRibbon />
        <HowItWorks />
        <Features />
        <AppPreview />
        <Cookbook />
        <WhyHooshpaz />
        <Pricing />
        <FAQ />
        <CTA />
    </div>
);

export default Home;
